var _g, _g2, _defs, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 174.061 174.061",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "SVGID_1_",
    cx: 87.03,
    cy: 87.03,
    rx: 86.987,
    ry: 87.03
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      clipPath: "url(#SVGID_2_)",
      fill: "#8a4ca8"
    },
    cx: 87.03,
    cy: 87.03,
    rx: 86.987,
    ry: 87.03
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4a312c"
    },
    d: "M73.446,35.649c3.495-5.794,31.362-10.904,42.73,9.693 c11.369,20.598,5.642,27.814,11.913,35.084c6.273,7.27,0.366,23.954-3.991,25.416c-4.357,1.463-2.608,7.232-0.482,9.711 c9.071,10.582-4.047,28.422-39.07,28.239c-37.436-0.196-44.782-20.942-35.183-27.414c3.129-2.111,4.342-6.164,0.914-9.735 c-3.428-3.57-11.332-16.875-3.885-27.779C53.843,67.96,47.334,35.632,73.446,35.649z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#293347"
    },
    d: "M99.268,120.444c-0.263,0.414-26.086,0.824-26.372,1.232 c-8.109,11.569-25.633,16.639-39.567,19.754c-13.865,3.101-14.401,20.714-14.423,32.444h135.177 c-0.02-11.73-0.278-29.28-14.425-32.444C125.51,138.268,106.961,132.542,99.268,120.444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ffdbb4"
    },
    d: "M72.951,95.736v22.216v10.965 c6.786,13.883,18.969,14.244,27.087,0v-10.966V95.736C100.038,77.821,72.951,77.821,72.951,95.736z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.3947 -0.9188 0.9188 0.3947 -9.1822 164.3109)",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ffdbb4"
    },
    cx: 120.109,
    cy: 89.124,
    rx: 9.665,
    ry: 5.59
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#ffdbb4"
    },
    d: "M86.495,118.688c-8.818,0-27.446-13.862-33.205-33.718 c-5.814-20.049,5.136-48.806,33.205-48.806c28.067,0,39.021,28.757,33.204,48.806C113.938,104.825,95.312,118.688,86.495,118.688z "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M67.888,78.49c0,0,1.489,2.516,6.07,2.516c4.58,0,5.384-2.151,5.43-2.909 c0,0-1.76-2.988-5.368-2.988S67.888,78.49,67.888,78.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: 57.8721,
    cy: 62.2598,
    r: 2.4406,
    gradientTransform: "matrix(1.0716 0 0 1.0717 11.7475 11.3333)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4524,
    style: {
      stopColor: "#2E6232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4626,
    style: {
      stopColor: "#326834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#407D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5669,
    style: {
      stopColor: "#4B8E45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6365,
    style: {
      stopColor: "#529A4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7339,
    style: {
      stopColor: "#57A14D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58A34E"
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_3_)"
    },
    cx: 73.762,
    cy: 78.057,
    r: 2.616
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E6232"
    },
    d: "M73.762,75.704c1.298,0,2.353,1.055,2.353,2.353c0,1.297-1.056,2.353-2.353,2.353 c-1.297,0-2.351-1.055-2.351-2.353C71.411,76.76,72.466,75.704,73.762,75.704 M73.762,75.179 c-1.589,0-2.877,1.289-2.877,2.879c0,1.59,1.288,2.878,2.877,2.878c1.59,0,2.879-1.289,2.879-2.878 C76.641,76.467,75.352,75.179,73.762,75.179L73.762,75.179z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 73.763,
    cy: 78.057,
    r: 1.202
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M105.185,78.49c0,0-1.489,2.516-6.07,2.516c-4.58,0-5.384-2.151-5.43-2.909 c0,0,1.76-2.987,5.368-2.987S105.185,78.49,105.185,78.49z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_4_",
    cx: -470.7817,
    cy: 78.0574,
    r: 2.6151,
    gradientTransform: "matrix(-1 0 0 1 -371.4716 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4524,
    style: {
      stopColor: "#2E6232"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4626,
    style: {
      stopColor: "#326834"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5104,
    style: {
      stopColor: "#407D3E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5669,
    style: {
      stopColor: "#4B8E45"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6365,
    style: {
      stopColor: "#529A4A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7339,
    style: {
      stopColor: "#57A14D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#58A34E"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_4_)"
    },
    d: "M99.311,80.672c-1.442,0-2.616-1.173-2.616-2.615s1.174-2.615,2.616-2.615 c1.441,0,2.614,1.173,2.614,2.615S100.752,80.672,99.311,80.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2E6232"
    },
    d: "M99.311,75.705c1.297,0,2.351,1.055,2.351,2.352c0,1.297-1.055,2.352-2.351,2.352 c-1.298,0-2.353-1.055-2.353-2.352C96.958,76.76,98.013,75.705,99.311,75.705 M99.311,75.18c-1.591,0-2.879,1.288-2.879,2.878 c0,1.589,1.288,2.878,2.879,2.878c1.588,0,2.877-1.289,2.877-2.878C102.188,76.468,100.899,75.18,99.311,75.18L99.311,75.18z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.311,
    cy: 78.057,
    r: 1.202
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E48F67"
    },
    d: "M81.492,90.55c-0.716,0.435-0.869,1.168-0.129,1.701c1.237,0.892,2.997,0.974,4.461,0.973 c1.536-0.001,3.361-0.138,4.694-0.978c0.683-0.43,1.163-1.815,0.206-2.236c-0.181-0.08-0.463,0.008-0.441,0.253 c0.029,0.325,0.334,0.63,0.275,0.929c-0.079,0.396-0.675,0.617-0.995,0.74c-0.996,0.383-2.119,0.446-3.173,0.475 c-0.935,0.025-5.768,0.093-4.764-1.724C81.672,90.6,81.578,90.498,81.492,90.55L81.492,90.55z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#924A0B"
    },
    d: "M62.742,69.909c5.516-1.25,11.303-1.717,16.418,1.204c0.34,0.194,0.639-0.32,0.306-0.523 c-4.5-2.739-12.105-3.576-16.761-0.771C62.656,69.849,62.688,69.921,62.742,69.909L62.742,69.909z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#924A0B"
    },
    d: "M110.158,69.82c-4.657-2.805-12.261-1.969-16.761,0.771c-0.333,0.203-0.034,0.717,0.306,0.523 c5.115-2.921,10.902-2.454,16.418-1.204C110.174,69.921,110.206,69.849,110.158,69.82L110.158,69.82z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0463A"
    },
    d: "M97.104,102.172c0,0-8.211-3.383-9.416-1.819c-0.07,0.094-0.136,0.186-0.193,0.278 c-0.058-0.093-0.124-0.185-0.194-0.278c-1.204-1.563-9.417,1.819-9.417,1.819s4.552,5.902,9.626,5.805 c5.229,0.195,9.573-5.805,9.573-5.805c-0.004,0-0.006,0-0.007,0C97.092,102.172,97.104,102.172,97.104,102.172z M93.366,102.172 c0,0-2.91,2.737-6.119,2.774c-1.923,0.024-3.862-2.236-5.596-2.97c0,0,2.692,0.353,5.831,0.335 C89.447,102.3,91.572,101.684,93.366,102.172z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M87.482,102.312c-3.139,0.018-5.831-0.335-5.831-0.335c1.046,1.128,3.673,2.994,5.596,2.97 c3.209-0.037,6.119-2.774,6.119-2.774C91.572,101.684,89.447,102.3,87.482,102.312z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#4a312c"
    },
    d: "M79.888,61.026c-6.887,13.773-9.682,17.84-18.839,14.203 c-9.156-3.635-8.417,6.555-6.753,13.826c-8.109-9.82-6.156-19.145-3.634-28.627c2.764-10.39,16.706-26.197,29.783-25.906 c7.105-0.713,17.859,0.131,29.301,7.992c19.976,13.732,13.305,44.587,7.923,48.226c5.212-28.577-7.549-22.76-16.356-37.708 C98.419,46.46,87.375,46.054,79.888,61.026z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.105,
    y: 139.608,
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    width: 2.777,
    height: 34.267
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeWidth: 1.3211,
      strokeMiterlimit: 10
    },
    points: " 72.952,121.649 63.285,130.485 75.578,149.563 86.187,139.497 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeWidth: 1.3211,
      strokeMiterlimit: 10
    },
    points: " 100.038,121.585 109.703,130.794 96.794,149.563 86.187,139.497 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a312c"
    },
    d: "M57.226,67.035c-1.713,5.548-5.596,9.171-3.289,15.413c1.805,4.882,6.715,12.709,1.657,17.097 c2.19,0.907,4.38,1.814,6.57,2.721c-0.715-5.491-1.305-10.078-3.325-15.286c-1.489-3.839-1.967-10.556,1.864-13.234 c-1.876-1.077-3.752-2.153-5.628-3.23c-0.147,7.933-2.771,15.889,1.11,23.33c2.167,4.154,8.373,0.492,6.26-3.659 c-2.918-5.733-0.097-13.562,0.11-19.67c0.093-2.724-3.289-4.812-5.628-3.23c-4.858,3.287-6.543,8.25-6.706,13.946 c-0.091,3.177,0.682,6.333,1.806,9.271c1.629,4.257,1.946,8.323,2.577,12.786c0.434,3.071,4.535,3.42,6.433,1.698 c5.651-5.131,4.58-12.891,2.077-19.356c-1.462-3.776-3.723-6.454-2.704-10.668c0.856-3.544,0.867-5.794-1.729-8.313 C58.203,66.186,57.419,66.407,57.226,67.035L57.226,67.035z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a312c"
    },
    d: "M114.089,64.967c1.468,7.813,3.473,14.689,2.157,22.744c-0.917,5.616-4.2,10.949-3.139,16.751 c0.109,0.597,1.093,0.75,1.342,0.176c5.321-12.251,8.757-28.238,1.018-40.251C114.99,63.645,113.932,64.134,114.089,64.967 L114.089,64.967z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.b546b3c9d20eb86a2beecfa55a60e1d3.svg";
export { ForwardRef as ReactComponent };